import { createWebHistory, createRouter } from "vue-router";
import { auth, guestAuth } from "@/middleware";
import { activityLogger } from "@/services/activityLogger";
import {
  isBanobagiAvailabilityEnabled,
  isBanobagiSiteClosed
} from "@/utils/banobagiAvailability";
const brand = "";
import { defineAsyncComponent } from "vue";
import CustomForm from "@/views/page/customForm/detail.vue";
import ProfilePage from "@/views/page/profile";
import EditTelephone from "@/views/page/editprofile/telephone.vue";
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/close",
      name: "Banobagi Close",
      component: () => import("@/views/page/banobagi/Close.vue"),
      meta: { requiresAuth: false, title: "BANOBAGI" }
    },
    {
      path: "/",
      name: "landing page",
      alias: [""],
      component: () => import("@/views/redirect.vue"),
      meta: {
        // requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/validatetelephone",
      name: "validatetelephone",
      component: () => import("@/views/page/validateTelephone"),
      meta: {
        guestAuth: true,
        title: `${brand}`
        // isShowV1Header: true
      }
    },
    {
      path: "/confirmotp",
      name: "confirmotp",
      component: () => import("@/views/page/validateTelephone/confirmOTP.vue"),
      meta: {
        // requiresAuth: true,
        title: `${brand}`
        // isShowV1Header: true
      }
    },
    {
      path: "/type",
      name: "user type",
      component: () => import("@/views/page/validateTelephone/type.vue"),
      meta: {
        // requiresAuth: true,
        title: `${brand}`
        // isShowV1Header: true
      }
    },
    {
      path: "/card-verification",
      name: "user verification select type",
      exact: true,
      component: () => import("@/views/page/validateTelephone/cardVerify.vue"),
      meta: {
        // requiresAuth: true,
        title: `${brand}`,
        isShowV1Header: true
      }
    },
    {
      path: "/card-verification-type/:id",
      name: "user verification insert type",
      exact: true,
      component: () =>
        import("@/views/page/validateTelephone/insertVerification.vue"),
      meta: {
        // requiresAuth: true,
        title: `${brand}`,
        isShowV1Header: true
      }
    },
    {
      path: "/coupon",
      name: "coupon-redeem",
      component: () => import("@/views/page/coupon/coupon.vue"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/coupon/:couponUser/:couponKey",
      name: "coupon-redeem-detail",
      component: () => import("@/views/page/coupon/detail/Detail.vue"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/couponhistory/:id",
      name: "coupon-history-detail",
      component: () =>
        import("@/views/page/privilege/detail/CouponHistory.vue"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/register",
      name: "register",
      component: () => import("@/views/page/register"),
      meta: { title: brand }
    },

    {
      path: "/edit-profile-required",
      name: "edit profile required fields",
      component: () => import("@/views/page/completeProfile"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/form/:id",
      name: "Custom Object",
      component: () => import("@/views/page/customForm"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/preview-form/:id",
      name: "Custom Object Preview Form",
      component: CustomForm,
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: ProfilePage,
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/manage",
      name: "manage profile",
      component: () => import("@/views/page/editprofile"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/manage/profile",
      name: "editprofile",
      component: defineAsyncComponent(() =>
        import("@/views/page/editprofile/editProfilePanel.vue")
      ),
      meta: {
        requiresAuth: true,
        title: `Manage Profile`,
        standardV2Header: {
          titleKey: "profile",
          showBack: true
        }
      }
    },
    {
      path: "/banobagi/profile",
      name: "banobagi-profile",
      component: () =>
        import("@/views/page/editprofile/BanobagiReadonlyProfile.vue"),
      meta: {
        requiresAuth: true,
        title: brand,
        banobagiHeader: {
          titleKey: "profile_general",
          showBack: true,
          emphasized: true
        }
      }
    },

    {
      path: "/privilege",
      name: "privilege",
      component: () => import("@/views/page/privilege"),
      meta: {
        requiresAuth: true,
        title: brand,
        standardV2Header: {
          titleKey: "privilege",
          showBack: true,
          actions: [
            { key: "filter", icon: ["fas", "sliders-h"] },
            { key: "redeem-code", icon: ["fas", "gift"] }
          ]
        }
      }
    },
    {
      path: "/all-privilege",
      name: "all-privilege",
      component: () => import("@/views/page/allPrivilege"),
      meta: {
        requiresAuth: true,
        title: brand
        // standardV2Header: {
        //   titleKey: "all_privilege",
        //   showBack: true
        // }
      }
    },
    {
      path: "/purchase-history",
      name: "purchase-history",
      component: () => import("@/views/page/purchaseHistory"),
      meta: {
        requiresAuth: true,
        title: brand,
        standardV2Header: {
          titleKey: "transaction_header",
          showBack: true
        },
        banobagiHeader: {
          titleKey: "transaction_header",
          showBack: true,
          emphasized: true
        }
      }
    },
    {
      path: "/privilege/:privilegeId",
      name: "privilege-detail",
      component: () => import("@/views/page/privilege/detail/Detail.vue"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/privilegehistory/:id",
      name: "privilege-history-detail",
      component: () => import("@/views/page/privilege/detail/DetailHistory.vue")
    },
    {
      path: "/privilege/set/:id",
      name: "privilege-set-detail",
      component: () => import("@/views/page/privilege/detail/PrivilegeSet.vue")
    },

    {
      path: "/point",
      name: "point",
      component: () => import("@/views/page/point"),
      meta: {
        requiresAuth: true,
        title: brand,
        standardV2Header: {
          titleKey: "your_spending",
          showBack: true
        }
      }
    },
    {
      path: "/branchPoint",
      name: "Branch Point",
      component: () => import("@/views/page/point/branch.vue"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },

    {
      path: "/spa-wallet",
      name: "spa-wallet",
      component: () => import("@/views/page/spaWallet"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/spa-wallet/:mode",
      name: "Spa Wallet Log",
      component: () => import("@/views/page/point/log.vue"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/events",
      name: "events",
      component: () => import("@/views/page/events"),
      meta: { title: brand, requiresAuth: true }
    },
    {
      path: "/events/landing",
      name: "landing",
      component: () => import("@/views/page/events/landing"),
      meta: { title: brand, requiresAuth: true }
    },

    {
      path: "/review",
      name: "review",
      component: () => import("@/views/page/review"),
      meta: { title: brand }
    },
    {
      path: "/manage/profile/edit/:type",
      name: "editprofile-telephone",
      component: EditTelephone,
      meta: {
        title: `${brand}`
      }
    },
    {
      path: "/confirmotpedit",
      name: "confirmotpedit",
      component: () => import("@/views/page/editprofile/confirmotpedit.vue"),
      meta: {
        title: `${brand}`
      }
    },
    {
      path: "/news",
      name: "news",
      component: () => import("@/views/page/news"),
      meta: {
        standardV2Header: {
          titleKey: "news_and_promotion",
          showBack: true
        }
      }
    },
    {
      path: "/news/:newsId",
      name: "news-detail",
      component: () => import("@/views/page/news/detail/Detail.vue"),
      meta: {
        requiresAuth: true,
        title: `news-detail`,
        standardV2Header: {
          compactBack: true
        }
      }
    },
    {
      path: "/benefits",
      name: "benefits",
      component: () => import("@/views/page/benefits"),
      meta: {
        requiresAuth: true,
        title: brand
      }
    },
    {
      path: "/reward",
      name: "reward",
      component: () => import("@/views/page/reward"),
      meta: {
        requiresAuth: true,
        title: `Reward`,
        standardV2Header: {
          titleKey: "redeem_text",
          showBack: true
        }
      }
    },
    {
      path: "/reward/:rewardId",
      name: "Reward Detail",
      exact: true,
      component: () => import("@/views/page/reward/detail/Detail.vue"),
      meta: {
        requiresAuth: true,
        title: `Reward`
      }
    },
    {
      path: "/reward/privilege/:rewardId",
      name: "Reward Privilege Detail",
      exact: true,
      component: () =>
        import("@/views/page/reward/detail/DetailRewardPrivilege.vue"),
      meta: {
        requiresAuth: true,
        title: `Reward`
      }
    },
    {
      path: "/rewardhistory",
      name: "reward-history",
      component: () => import("@/views/page/reward/detail/History.vue")
    },
    {
      path: "/rewardhistory/:id",
      name: "reward-history-detail",
      exact: true,
      component: () => import("@/views/page/reward/detail/DetailHistory.vue")
    },
    {
      path: "/editaddress/:id",
      name: "reward-edit-address",
      component: () =>
        import("@/views/page/reward/detail/DetailEditAddress.vue"),
      meta: {
        requiresAuth: true,
        title: `${brand}`
      }
    },
    {
      path: "/form",
      name: "campaign form",
      component: () => import("@/views/page/campaignform"),
      meta: {
        requiresAuth: true,
        title: `Form`
      }
    },
    {
      path: "/setting",
      name: "Setting PDPA",
      component: () => import("@/views/page/settingpdpa"),
      meta: {
        requiresAuth: true,
        title: `Setting`
      }
    },
    {
      path: "/policy",
      name: "policy",
      component: () => import("@/views/page/policy"),
      meta: {
        requiresAuth: true,
        title: `Policy`
      }
    },
    {
      path: "/terms",
      name: "terms",
      component: () => import("@/views/page/terms"),
      meta: {
        requiresAuth: true,
        title: `Terms`
      }
    },
    {
      path: "/marketplace",
      name: "Marketplace",
      component: () => import("@/views/page/marketplace"),
      meta: {
        requiresAuth: true,
        title: `Marketplace`
      }
    },
    {
      path: "/connectMarketplace",
      name: "Marketplace Connect",
      component: () => import("@/views/page/marketplace/connectMarketplace"),
      meta: {
        requiresAuth: true,
        title: `Marketplace`
      }
    },
    {
      path: "/game",
      name: "Game",
      component: () => import("@/views/page/game"),
      meta: {
        requiresAuth: true,
        title: `Redirect Game`
      }
    },
    {
      path: "/stampcard",
      name: "Stampcard",
      component: () => import("@/views/page/stampcard"),
      meta: {
        requiresAuth: true,
        title: `Stamp Card`
      }
    },
    {
      path: "/stampcard/detail/:id",
      name: "Stampcard Detail",
      exact: true,
      component: () => import("@/views/page/stampcard/detail"),
      meta: {
        requiresAuth: true,
        title: `Stamp Card`
      }
    },
    {
      path: "/booking",
      name: "booking",
      component: () => import("@/views/page/booking"),
      meta: {
        requiresAuth: true,
        title: `Booking`
      }
    },
    {
      path: "/transaction-summary",
      name: "Transaction-Summary",
      component: () => import("@/views/page/transactionHistory"),
      meta: {
        title: `Transaction Summary`
      }
    },
    {
      path: "/transaction-summary/:id",
      name: "Transaction-Summary-Detail",
      component: () => import("@/views/page/transactionHistory/detail"),
      meta: {
        title: `YOUR ORDER SUMMERY`
      }
    },
    {
      path: "/transaction-summary/:id/preview",
      name: "Transaction-Summary-Detail-RECEIPT",
      component: () => import("@/views/page/transactionHistory/preview"),
      meta: {
        title: `RECEIPT`
      }
    },
    {
      path: "/booking/detail/:id",
      name: "booking Detail",
      exact: true,
      component: () => import("@/views/page/booking/detail"),
      meta: {
        requiresAuth: true,
        title: `Booking Detail`
      }
    },
    {
      path: "/member/:id",
      name: "Member Description",
      component: () => import("@/views/page/member"),
      meta: {
        requiresAuth: true,
        title: `${brand}`,
        standardV2Header: {
          titleKey: "member_benefit",
          showBack: true
        }
      }
    },
    {
      path: "/kis",
      name: "KIS Transaction",
      component: () => import("@/views/page/kis"),
      meta: {
        // requiresAuth: true,
        title: `KIS Transaction`
      }
    },
    {
      path: "/invite/:id",
      name: "Friend Get Friend Invite",
      exact: false,
      component: () => import("@/views/page/FriendGetFriend"),
      meta: {
        // requiresAuth: true,
        title: `Friend Get Friend`
      }
    },
    {
      path: "/invite/:id/list",
      name: "Friend Get Friend Invite List",
      exact: false,
      component: () => import("@/views/page/FriendGetFriend/inviteList.vue"),
      meta: {
        // requiresAuth: true,
        title: `Friend Get Friend`
      }
    },
    {
      path: "/reward-transaction",
      name: "Reward From Transaction code List",
      exact: true,
      component: () => import("@/views/page/transactionReward"),
      meta: {
        requiresAuth: true,
        title: `Reward From Transaction code`
      }
    },
    {
      path: "/reward-transaction/detail/:id",
      name: "Reward From Transaction code Detail",
      exact: true,
      component: () => import("@/views/page/transactionReward/detail"),
      meta: {
        requiresAuth: true,
        title: `Reward From Transaction code`
      }
    },
    {
      path: "/reward-transaction/detail/:id/coupon",
      name: "Coupon From Transaction code Detail",
      component: () => import("@/views/page/transactionReward/couponDetail"),
      meta: {
        requiresAuth: true,
        title: `Reward From Transaction code Code`
      }
    },
    {
      path: "/reward-transaction/detail/:id/editaddress",
      name: "EditAddress Transaction code Detail",
      component: () => import("@/views/page/transactionReward/editAddress"),
      meta: {
        requiresAuth: true,
        title: `Random Reward Edit Address`
      }
    },
    {
      path: "/reward-transaction/detail/:id/addressdetail",
      name: "Address Transaction code Detail",
      component: () => import("@/views/page/transactionReward/detailAddress"),
      meta: {
        requiresAuth: true,
        title: `Random Reward Address Detail`
      }
    },
    {
      path: "/transaction",
      name: "Transaction",
      component: () => import("@/views/page/transaction"),
      meta: {
        requiresAuth: true,
        title: `Transaction`
      }
    },
    {
      path: "/configuration/language",
      name: "Language",
      component: () => import("@/views/page/setting/language"),
      meta: {
        requiresAuth: true,
        title: `Language`
      }
    },
    {
      path: "/configuration",
      name: "configuration",
      component: () => import("@/views/page/setting"),
      meta: {
        requiresAuth: true,
        title: `Setting`
      }
    },
    {
      path: "/transaction/detail/:id",
      name: "Transaction Detail",
      component: () => import("@/views/page/transaction/detail"),
      meta: {
        requiresAuth: true,
        title: `Transaction`
      }
    },
    {
      path: "/receipt/upload",
      name: "receipt upload",
      component: () =>
        import("@/views/page/receiptScanner/ReceiptUploadEntry.vue"),
      meta: {
        requiresAuth: true,
        title: `Receipt Upload`
        // banobagiHeader: {
        //   // useBrandTitle: true,
        //   compactBack: true
        // }
      }
    },
    {
      path: "/mission",
      name: "Mission Page",
      component: () => import("@/views/page/mission"),
      meta: {
        requiresAuth: true,
        title: `Mission`,
        standardV2Header: {
          titleKey: "mission_title",
          showBack: true
        }
        // standardV2Header: {
        //   titleKey: "privilege",
        //   showBack: true,
        //   actions: [
        //     { key: "filter", icon: ["fas", "sliders-h"] },
        //     { key: "redeem-code", icon: ["fas", "gift"] }
        //   ]
        // }
      }
    },
    {
      path: "/mission/:type/:id",
      name: "Mission Detail",
      component: () => import("@/views/page/mission/detail.vue"),
      meta: {
        requiresAuth: true,
        title: `Mission`
      }
    },
    {
      path: "/mission-info/:id/:m_id",
      name: "Mission Detail Reward Info",
      component: () => import("@/views/page/mission/info.vue"),
      meta: {
        requiresAuth: true,
        title: `Mission`,
        standardV2Header: {
          compactBack: true
        }
      }
    },
    {
      path: "/mission-info/address/:id/:m_id",
      name: "Mission Detail Address Edit",
      component: () => import("@/views/page/mission/editAddress.vue"),
      meta: {
        requiresAuth: true,
        title: `Mission`,
        standardV2Header: {
          compactBack: true
        }
      }
    },
    {
      path: "/mission-info/reward/:id/:m_id",
      name: "Mission Detail reward detail Info",
      component: () => import("@/views/page/mission/rewardDetail.vue"),
      meta: {
        requiresAuth: true,
        title: `Mission`,
        standardV2Header: {
          compactBack: true
        }
      }
    },

    {
      path: "/receipt",
      name: "Receipt",
      component: () => import("@/views/page/receiptScanner"),
      meta: {
        requiresAuth: true,
        title: brand,
        banobagiHeader: {
          titleKey: "history_use",
          showBack: true,
          emphasized: true
        }
      }
    },
    {
      path: "/location",
      name: "location",
      component: () => import("@/views/page/location"),
      meta: { requiresAuth: false, title: `location` }
    },
    {
      path: "/frequently-asked-questions",
      name: "FAQ",
      component: () => import("@/views/page/frequentlyQuestions"),
      meta: { requiresAuth: false, title: `Frequently Asked Questions` }
    },
    {
      path: "/ticket",
      name: "ticket",
      component: () => import("@/views/page/ticket"),
      meta: { requiresAuth: false, title: `Customer Ticket` }
    },
    {
      path: "/ticket/:ticketId",
      name: "ticket detail",
      component: () => import("@/views/page/ticket/detail"),
      meta: { requiresAuth: false, title: `Customer Ticket` }
    },
    {
      path: "/ticket/create",
      name: "Create Ticket",
      component: () => import("@/views/page/ticket/create"),
      meta: { requiresAuth: false, title: `Create Customer Ticket` }
    },
    {
      path: "/:redeemId/:transactionCode",
      name: "redirect transaction",
      exact: true,
      component: () => import("@/views/page/redirectTransaction"),
      meta: {
        requiresAuth: true,
        title: `Transaction Code`
      }
    },
    {
      path: "/:pathName/:redeemId/:transactionCode",
      name: "redirect transaction From Link",
      exact: true,
      component: () => import("@/views/page/redirectTransaction"),
      meta: {
        requiresAuth: true,
        title: `Transaction Code`
      }
    },
    {
      path: "/force-logout",
      name: "redirect transaction From Link",
      exact: true,
      component: () => import("@/views/page/forceLogout.vue"),
      meta: {
        requiresAuth: true,
        title: `Redirect-Logout`
      }
    },
    {
      path: "/blank-theme-landing",
      name: "Landing Page For Blank Theme",
      exact: true,
      component: () => import("@/views/page/blank.vue"),
      meta: {
        requiresAuth: true,
        title: `Redirect-Logout`
      }
      // redirect: to => {
      //   return {
      //     path: "/transaction",
      //     query: { code: to.params.transaction_code }
      //   };
      // }
    },
    {
      path: "/qr",
      name: "qr",
      exact: true,
      component: () => import("@/views/page/profile/MemberQr.vue"),
      meta: { requiresAuth: true, hideHeader: true }

      // redirect: to => {
      //   return {
      //     path: "/transaction",
      //     query: { code: to.params.transaction_code }
      //   };
      // }
    },

    {
      path: "/banner-preview",
      name: "Banner Preview",
      exact: true,
      component: () => import("@/views/page/bannerPreview"),
      meta: {
        title: `Banner Preview`
      }
    },
    {
      path: "/widget",
      name: "for dev",
      exact: true,
      component: () => import("@/views/page/dev.vue")

      // redirect: to => {
      //   return {
      //     path: "/transaction",
      //     query: { code: to.params.transaction_code }
      //   };
      // }
    },
    {
      path: "/:catchAll(.*)",
      name: "Page404",
      component: () => import("@/views/page/404")
    }
  ]
});
router.beforeEach(async (to, from, next) => {
  if (isBanobagiSiteClosed()) {
    return to.name === "Banobagi Close"
      ? next()
      : next({ name: "Banobagi Close", replace: true });
  }
  if (to.name === "Banobagi Close" && !isBanobagiAvailabilityEnabled()) {
    return next({ path: "/", replace: true });
  }

  const context = {
    from,
    next,
    router,
    to
  };

  // Log page activity
  if (to.name) {
    activityLogger.logPageView(to.name, to.path, to.params);
  }

  if (to.meta.requiresAuth || to.meta.guestAuth) {
    const middleware = to.meta.requiresAuth ? auth : guestAuth;
    return await middleware({ ...context });
  }
  next();
});
export default router;
